






































































































import { Usuario } from "@/typings/store/plugins/easyFirestore/usuarios";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import "@/helpers/extensions";
import InfoBar from "@/components/InfoBar.vue";
import { mapGetters } from "vuex";
import { Ruta } from "@/typings/store/modules/rutas";
import SVGIcon from "@/components/SVGIcon.vue";

@Component({
  computed: mapGetters({
    getRutas: "rutas/getRutas",
    getRutasUsuario: "usuario/getRutas",
  }),
  components: { InfoBar, SVGIcon },
})
export default class AppBar extends Vue {
  @Prop() readonly usuario?: Usuario;
  @Prop() readonly items!: Array<Ruta>;
  drawerLeft = false;

  grupoContratos = false; // Controla el estado expandido/cerrado del grupo "Contratos"
  mostrarContratos = true; // Otros datos de tu componente aquí
  mostrarContratosClientes = false; // Controla la visibilidad del grupo "Clientes"
  grupoContratosClientes = true;

  get urlImg(): string {
    return Object.values(this.usuario?.imagen ?? {}).firstOrNull?.url ?? "";
  }

  get sudo(): boolean {
    if (!this.usuario) {
      return false;
    }
    return this.usuario.tipo == "sudo";
  }

  @Emit("click-nav-icon")
  onClickNavIcon(): void {
    return;
  }

  @Emit("click-empresa")
  onClickEmpresa(): void {
    return;
  }

  @Emit("abrir-login")
  onAbrirLogin(): void {
    return;
  }

  @Emit("logout")
  onLogout(): void {
    this.goTo("inicio");
    return;
  }

  @Emit("input")
  onInput(value: boolean): boolean {
    return value;
  }
  get itemsRutas(): Array<Ruta> {
    return this.getRutasArray;
  }
  get rutasUsuario(): Array<Ruta> {
    return this.getRutasUsuario;
  }
  to(ruta: Ruta): void {
    if (ruta.to && this.$route.name !== ruta.to?.name) {
      this.$router.push(ruta.to);
    }
  }

  get hideSlider(): boolean {
    return !this.items.some(
      (ruta) =>
        ruta.id.toLowerCase() === this.actualRute.toLowerCase() && ruta.show
    );
  }

  get actualRute(): string {
    return this.$route.name ?? "";
  }
  async goTo(ruta: string): Promise<void> {
    if (this.$route.name !== ruta) {
      await this.$router.push({ name: ruta });
    }
  }

  async move(name: string): Promise<void> {
    if (this.$route.name !== "inicio") {
      await this.goTo("inicio");
    }
    this.$vuetify.goTo(`#${name}`);
  }
}
